

import React from 'react';
import formatters from "../../../utils/forms/formatters";
import nameMaps from "../../../utils/forms/nameMaps";
import {startCase, toLower} from 'lodash';


export default class DataListCard extends React.Component {

     static defaultProps = {
         data: {},
         title: '',
     };


     renderLineItem = (key, val) => {
         return (
            <div className={'my-1 columns'} key={key}>
                <span className={'column py-1 mr-6 is-one-third'}>{startCase(toLower(key))}</span>
                {val ?
                    <span className={'has-text-weight-semibold column py-1'}>{val}</span> :
                    <span className={'has-text-grey-light column py-1'}>--</span>
                }
            </div>
         )
     }

     renderLineItems = obj => {
         return Object.keys(obj).map(k => this.renderLineItem(k, obj[k]))
     };

     render() {

         return (
             <div className={'card my-3 p-3'}>
                 <h4 className={'has-text-primary is-size-4 mb-4 has-text-weight-semibold'}>{this.props.title}</h4>

                 {this.renderLineItems(this.props.data)}

                 {(this.props.onEdit || this.props.onRemove) &&
                     <div className={'buttons mt-4 is-right'}>
                         {this.props.onEdit &&
                            <div className={'button has-text-primary'}
                                 onClick={this.props.onEdit}>Edit</div>
                         }
                         {this.props.onRemove &&
                         <div className={'button has-text-danger'}
                              onClick={this.props.onRemove}>Remove</div>
                         }
                     </div>
                 }

             </div>
         )

     }
}
